<template>
  <Modal v-model="recordModel" v-bind="modelBase">
    <div v-if="recordList.length === 0">暂无中奖纪录</div>
    <ul class="record-list">
      <li v-for="(item, index) in recordList" :key="index">
        <h3>{{item.goods_name}}<span>{{item.good_code}}</span></h3>
        <p>{{item.create_time}}</p>
      </li>
    </ul>
  </Modal>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      recordModel: false,
      modelBase: {
        title: '中奖纪录',
        'footer-hide': true,
      },
      recordList: [],
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo,
      isLogin: state => state.login.isLogin,
    }),
  },
  methods: {
    async setRecordModel() {
      if (!this.isLogin) {
        this.$store.commit('setShowLogin', true);
        return;
      }
      this.recordModel = true;
      const res = await axios.post('/api/winRecord', {
        user_id: this.userInfo.union_user_id || this.userInfo.openid,
        f_id: 1,
      });
      if (res.data.ret === 1) {
        this.recordList = res.data.content.reverse();
      }
    },
  },
};
</script>

<style>
.record-list li{
  margin-bottom: 4%;
}
.record-list span{
  margin-left: 4%;
  color: #999;
}
</style>




// WEBPACK FOOTER //
// src/components/winRecord.vue